import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, onBeforeMount } from 'vue'

import { platform } from '@/services/platform'
import { QuestionnaireView } from '@/models/onboarding'
import { DailyGoalPage } from '@/models/onboarding.types'

import Layout from '../Layout.vue'
import DailyGoalWheel from '../DailyGoalWheel.vue'
import DailyGoalSlider from '../DailyGoalSlider.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DailyGoal',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as DailyGoalPage
})

onBeforeMount(async () => {
  // Set the default value to 20.
  props.view.setCurrentChoice(20)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-daily-goal",
    title: page.value.title,
    subtitle: page.value.subtitle
  }, {
    default: _withCtx(() => [
      (_unref(platform).isTouchScreen())
        ? (_openBlock(), _createBlock(DailyGoalWheel, {
            key: 0,
            class: "onboarding-daily-goal__wheel",
            view: __props.view
          }, null, 8, ["view"]))
        : (_openBlock(), _createBlock(DailyGoalSlider, {
            key: 1,
            class: "onboarding-daily-goal__slider",
            view: __props.view
          }, null, 8, ["view"]))
    ]),
    _: 1
  }, 8, ["title", "subtitle"]))
}
}

})